// Configuration for Frontend
// In production, this might come from window.env or similar injection
// For now, we point to the backend's static serve route or the Nextcloud direct URL if preferred.
// However, since we implemented "Smart Serve" in backend (/uploads/...), we should point there.

// If we point to backend:
export const BASE_UPLOAD_URL = '';
// Note: If the DB path is 'uploads/foo.png', then URL becomes 'http://localhost:3000/uploads/foo.png'
// which matches our backend route app.use('/uploads', ...)

// If we wanted to point directly to Nextcloud (bypassing backend), we would use:
// export const BASE_UPLOAD_URL = 'https://cloud.beafon.com/remote.php/dav/files/PIM/';
// But that requires authentication headers which the browser image tag can't easily send.
// So pointing to backend is the correct approach for public/protected images.

export const PRODUCT_TYPES = ['normal', 'main', 'accessory', 'component', 'spare_part', 'packaging'];
